export default "__VITE_ASSET__BncUTYUn__"